var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgXls = function SvgXls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#06CF7F",
    d: "M15.054 0c.021.024.044.048.067.071l8.486 8.485c.12.121.253.223.393.307V28a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h13.054z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Rubik-Medium, Rubik",
    fontSize: 8,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.452,
    y: 19
  }, "XLS")), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M15 2l7 7h-7z"
  }))));
};
export default SvgXls;